var constant = function constant(a) {
  return function () {
    return a;
  };
};

export default constant;